/*
 * @Author: along longwang6@163.com
 * @Date: 2025-05-27 17:37:19
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2025-06-16 15:54:01
 * @FilePath: /ehr-web/src/http/axios.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { BusinessCode, ErrorMessage, HttpCode, IResponseData } from './config';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { BusinessError, HttpError, transRes } from '@/http/utils';
import { logout } from '@/utils/auth';
import { LocalStorageKey } from '@/constants/storage';
import { getOrg } from '@/utils/hooks/useOrg';

const axiosInstance = axios.create({
  timeout: 50000,
  withCredentials: true,
});

// http request 拦截器
axiosInstance.interceptors.request.use(
  (axiosRequestConfig: AxiosRequestConfig) => {
    let { orgId = '' } = getOrg();
    if (!orgId) {
      orgId = localStorage.getItem(LocalStorageKey.ORGANIZATION_ID) || '';
    }
    const token = localStorage.getItem(LocalStorageKey.TOKEN) || '';

    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      h_mb_token: token,
      organization_id: orgId,
    };
    axiosRequestConfig.headers = {
      ...headers,
      ...axiosRequestConfig.headers,
    };
    return axiosRequestConfig;
  },
  (error: AxiosError) => {
    const code = HttpCode.UNKNOWN;
    return Promise.reject(new HttpError(code, error.message));
  }
);

// http response 拦截器
axiosInstance.interceptors.response.use(
  (response: AxiosResponse<IResponseData<any>>) => {
    const { status, data: resData } = response;
    const responseData = transRes(resData);
    if (status === HttpCode.SUCCESS) {
      const { code, msg } = responseData;
      switch (code) {
        case BusinessCode.SUCCESS:
          return Promise.resolve(responseData);
        default:
          return Promise.reject(new BusinessError(code, msg));
      }
    } else if (status === HttpCode.UNAUTHORIZED) {
      // 如果登录过期或者未登录
      logout();
      return Promise.reject(new HttpError(status, ''));
    } else {
      return Promise.reject(
        new HttpError(
          status,
          ErrorMessage[status] || ErrorMessage[HttpCode.SERVER_ERROR]
        )
      );
    }
  },
  (error: AxiosError) => {
    const status = error.response?.status;
    let code = status || HttpCode.UNKNOWN;
    let message = error?.message || ErrorMessage[code];
    // 超时
    if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      code = HttpCode.TIME_OUT;
      message = ErrorMessage[code];
    }

    if (code === HttpCode.UNAUTHORIZED) {
      message = '';
      logout();
    }

    return Promise.reject(new HttpError(code, message));
  }
);

export default axiosInstance;
